<template>
    <div>
    <base-header type="gradient-blue" class="pb-6 pb-8 pt-5 pt-md-8">
        <div class="row mb-2">
            <div class="col-12 col-md-12 col-lg-8">
                <h1 class="text-white pt-3 px-3">ตรวจสอบการลงทะเบียนคอมมิชชั่น</h1>
                <p
                    class="text-white pb-0 px-3"
                >ตรวจสอบเอกสารแต่ละร้านค้าในเครือข่ายของตนเอง เพื่อส่งเอกสารให้กับทีมงาน SHIPPOP</p>
            </div>
            <div class="col-12 col-md-12 col-lg-4 align-self-center text-right">
                <h1 class="display-3 text-white">
                    <small>จำนวนร้านค้าที่ลงทะเบียน :</small>
                    {{totalShop}}
                    <small>ร้าน</small>
                </h1>
            </div>
      </div>
    </base-header>
    <div class="text-center" v-if="busy">
        <BlockUI>
            <div class="loader"></div>
        </BlockUI>
    </div>
    <div class="container-fluid mt--7 mb-5">
        <div class="row">
            <div class="col">
                <div class="card shadow">
                    <div class="card-header bg-transparent">
                        <div class="row justify-content-between">
                            <div class="col-12 col-md-12 col-lg-12 col-xl-6">
                            </div>
                            <div class="col-12 col-md-6 col-lg-6 col-xl-4 mb-3">
                                <b-form-group
                                    id="input-group-1"
                                    label="ค้นหาข้อมูล"
                                    label-for="input-1"
                                    class="mb-0"
                                >
                                    <b-form-input
                                        id="input-1"
                                        type="text"
                                        v-model="filter"
                                        placeholder="ค้นหาข้อมูล"
                                    ></b-form-input>
                                </b-form-group>
                                <hr class="d-block d-md-none d-lg-none mb-0" />
                            </div>
                        </div>
                    </div>
                    <!-- table -->
                    <div id="tablePrint">
                        <b-table
                            show-empty
                            responsive
                            :items="shopCommissionSPAdmin"
                            :fields="fields"
                            :filter="filter"
                            class="scroll-bar-pop"
                            empty-text="ไม่มีข้อมูลร้านค้าที่ลงทะเบียน"
                            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
                        >
                            <template slot="index" slot-scope="data">{{ data.index+1 }}</template>
                            <template slot="created_at" slot-scope="data">{{ data.item.created_at }}</template>
                            <template slot="status" slot-scope="data">
                                <b-badge :variant="statusCommission( data.item.status ).color +' report'" >
                                    {{statusCommission( data.item.status ).status}}
                                </b-badge>
                            </template>
                            <template slot="manage" slot-scope="data">
                                <router-link :to="`/verify/${data.item.user_details_id}`" target="_blank">
                                    <button class="btn btn-sm btn-info px-3">ตรวจสอบข้อมูล</button>
                                </router-link>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalNotification :notiShop="noti" />
    </div> 
</template>
<script>
const API_URL = process.env.VUE_APP_API;
import validatePop from "../../plugins/validatePop.js"
import { statusCommission } from "../../plugins/statusCommission.js";
import ModalNotification from '@/components/custom/ModalNotification'
export default {
    name:"confirmCommissionSPAdmin",
    components:{
        ModalNotification
    },
    data(){
        return {
            busy: false,
            shopCommissionSPAdmin: [],
            date: new Date(),
            filter: null,
            filtersDate: {
                date_start: "",
                date_end: "",
                date_excel: ""
            },
            totalShop: 0,
            statusCommission: statusCommission,
            noti:{
                show:false,
                type:"",
                created_by:"",
                role:"",
                router:false
            },
        }
    },
    mounted(){
        this.checkStatusShop().then(res => {
            let status_shop = res.data.data.status_shop
            let created_by = res.data.data.created_by
            if( status_shop == 'LOCK' ){
                this.noti.created_by = created_by
                this.noti.type = status_shop
                this.noti.role = 'superadmin'
                this.noti.show = true
            }
        })
        this.getShopCommissionSPAdmin()
    },
    methods:{
        getShopCommissionSPAdmin() {
            this.busy = true
            this.$http
                .get(API_URL + "/shop/check/register/commisstion", {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop(res);
                    if (!checkError.status) {
                        this.handleLoader();
                        if (checkError.notices == "token is expired") {
                            this.$router.push("/logout");
                        }
                        this.showErrorModal(checkError.msg);
                        return false;
                    }
                    this.handleLoader();
                    this.shopCommissionSPAdmin = res.data.data;
                    this.totalShop = this.shopCommissionSPAdmin.length
                });
        },
        handleLoader(){
            this.busy = !this.busy
        },
        checkStatusShop(){
            return new Promise((resolve, reject) => {
                this.$http
                .get(API_URL + "/shop/noti", {
                    headers: {
                    Token: localStorage.getItem("access_token")
                    }
                })
                .then(res => {
                    let checkError = validatePop( res )
                    if( !checkError.status ){
                        if( checkError.notices == "token is expired"){
                        this.$router.push("/logout")
                        }
                        this.showErrorModal( checkError.msg )
                        this.busy = false
                        return false
                    } 
                    resolve(res)
                })
                .catch(error => {
                    this.showErrorModal("พบปัญหาการเชื่อมต่อ กรุณาติดต่อ...");
                });
            });
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "SUCCESS",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "ตกลง",
            contentClass: "modal-success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "ERROR",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: OkmsgTitle,
            contentClass: "modal-errors",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
    },
    computed:{
        fields(){ 
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "created_at", label: "วันที่ส่งข้อมูล", sortable: true },
                { key: "shop_name", label: "ชื่อร้านค้า", sortable: true },
                { key: "owner_name", label: "ชื่อเจ้าของ", sortable: true },
                { key: "status", label: "สถานะ", sortable: true },
                { key: "manage", label: "การจัดการ" }
            ]
            return fields
        }
    }
}
</script>
<style lang="scss">
  .report{
    color: #212529;
    font-size: 1.1rem;
    width: 6rem;
  }
</style>